import { atom } from 'jotai';
import { TableDataState, TableFilters, TableState, TblStats, TblView } from '../../../../core/table/table.types';
import { tableStatsVM, tableViewVM, tableStateVM } from '../../../../core/table/table_view_models';

export type ProcessingErrorItem = {
    EventType: string;
    Entity: string;
    Logtime: string;
    Details: string;
    Status?: string;
    AlertSentStatus?: string;
};

export const procErrorsTableStateAtom = atom<TableState>(tableStateVM());
export const procErrorsTableViewAtom = atom<TblView>(tableViewVM());
export const procErrorsTableFiltersAtom = atom<TableFilters>({});
export const procErrorsTableStatsAtom = atom<TblStats>(tableStatsVM());
export const procErrorsDataAtom = atom<TableDataState<ProcessingErrorItem>>({ items: [], dataItems: [] });
